// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2vGnn","modalForm":"UpgradeEpcsModal_modalForm__2Gu0m","modalFooter":"UpgradeEpcsModal_modalFooter__3ahJY"};